module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_marco_comida_25.bdee21dd.png";